/* Carrito estilo Amazon — Moon Shop.
   Cambia cantidades sin recargar la página: solo se reemplazan el subtotal, la barra
   de envío y la lista. Los botones de compra (Releasit) no se tocan, así no desaparecen. */
(function () {
  if (window.__amzCarrito) { window.__amzCarrito(); return }

  function cuenta (n) {
    document.querySelectorAll('[data-amz-cuenta]').forEach(function (el) { el.textContent = n; el.hidden = !n })
  }

  function cambiar (raiz, linea, cantidad) {
    var sid = raiz.dataset.seccion
    raiz.classList.add('is-cargando')
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(linea), quantity: cantidad, sections: [sid], sections_url: location.pathname }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'No se pudo cambiar') }); return r.json() })
      .then(function (c) {
        cuenta(c.item_count)
        if (!c.item_count || !c.sections || !c.sections[sid]) { location.reload(); return }
        var nuevo = new DOMParser().parseFromString(c.sections[sid], 'text/html')
        raiz.querySelectorAll('[data-amz-parte]').forEach(function (viejo) {
          var otro = nuevo.querySelector('[data-amz-parte="' + viejo.dataset.amzParte + '"]')
          if (otro) viejo.replaceWith(otro)
        })
        document.dispatchEvent(new CustomEvent('amz:carrito', { detail: c }))
      })
      .catch(function (e) { alert(e.message) })
      .finally(function () { raiz.classList.remove('is-cargando') })
  }

  function carrito () {
    document.querySelectorAll('[data-amz-carrito]').forEach(function (raiz) {
      if (raiz.dataset.amzListo) return; raiz.dataset.amzListo = '1'
      raiz.addEventListener('click', function (e) {
        var item = e.target.closest('.amzk__item'); if (!item) return
        var linea = item.dataset.linea, n = Number(item.dataset.cantidad)
        if (e.target.closest('[data-amz-menos]')) { e.preventDefault(); cambiar(raiz, linea, n - 1) }
        else if (e.target.closest('[data-amz-mas]')) { e.preventDefault(); cambiar(raiz, linea, n + 1) }
        else if (e.target.closest('[data-amz-eliminar]')) { e.preventDefault(); cambiar(raiz, linea, 0) }
        else if (e.target.closest('[data-amz-compartir]')) {
          e.preventDefault()
          var url = item.dataset.url, nombre = (item.querySelector('.amzk__nombre') || {}).textContent || ''
          if (navigator.share) navigator.share({ title: nombre.trim(), url: url }).catch(function () {})
          else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { alert('Enlace copiado') })
        }
      })
      var nota = raiz.querySelector('[data-amz-nota]')
      if (nota) nota.addEventListener('change', function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: nota.value }) })
      })
    })
  }

  function recomendados () {
    document.querySelectorAll('[data-amz-relacionados]').forEach(function (s) {
      if (s.dataset.amzListo) return; s.dataset.amzListo = '1'
      /* 19-oct (Pablo): parecidos a TODO lo que lleva, no solo al primero. Una dirección por
         producto del carrito; se intercalan (1.º de cada uno, 2.º de cada uno…) sin repetir. */
      var urls = String(s.dataset.amzRelacionados).split('|').filter(Boolean), cuantos = Number(s.dataset.cuantos || 10)
      function clave (t) { var a = t.querySelector('a[data-enlace]'), m = a && String(a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/); return m ? decodeURIComponent(m[1]).toLowerCase() : '' }
      Promise.all(urls.map(function (u) {
        return fetch(u).then(function (r) { return r.ok ? r.text() : '' }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html'), c = d.querySelector('[data-amz-recomendados]')
          return c ? Array.prototype.slice.call(c.children) : []
        }).catch(function () { return [] })
      })).then(function (listas) {
        var viejo = s.querySelector('[data-amz-recomendados]'); if (!viejo) return
        var ya = {}, salen = [], i = 0, hay = true
        while (salen.length < cuantos && hay) {
          hay = false
          listas.forEach(function (l) {
            var t = l[i]; if (!t) return; hay = true
            var k = clave(t); if (salen.length >= cuantos || (k && ya[k])) return
            if (k) ya[k] = 1; salen.push(t)
          })
          i++
        }
        if (!salen.length) return
        viejo.innerHTML = ''; salen.forEach(function (t) { viejo.appendChild(document.importNode(t, true)) }); s.style.display = ''
      })
    })
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-amz-agregar]'); if (!b || b.disabled) return
    e.preventDefault(); b.disabled = true; var txt = b.textContent
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.amzAgregar), quantity: 1 }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || 'No se pudo agregar') }) })
      .then(function () {
        if (document.querySelector('[data-amz-carrito]')) { location.reload(); return }
        b.classList.add('is-listo'); b.textContent = 'Agregado ✓'
        /* En el carrito nuevo (amzt) lo agregado aparece en la lista sin recargar (Pablo, 26-oct: había que actualizar para verlo). */
        if (document.querySelector('[data-amzt-carrito]') && window.__amztRefrescarCarrito) window.__amztRefrescarCarrito()
        fetch('/cart.js').then(function (r) { return r.json() }).then(function (c) { cuenta(c.item_count) })
        setTimeout(function () { b.classList.remove('is-listo'); b.textContent = txt; b.disabled = false }, 2200)
      })
      .catch(function (er) { alert(er.message); b.disabled = false })
  })

  function todo () { carrito(); recomendados() }
  window.__amzCarrito = todo
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo()
  document.addEventListener('shopify:section:load', todo)
})()
